import { SharePointResourcesBaseModel } from '../../microsoft/sharepoint/share-point-resources-base-model';

export class SharePointPermanentAuditResourcesModel extends SharePointResourcesBaseModel {
  providerPolicy: string;
  userId: string|null;
}
